import PensionAnalysis from './PensionAnalysis.js';

export default PensionAnalysis;
